import { Optional, Inject, Injectable} from '@angular/core';
import { HttpClient} from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class SymbolService {
  private appSettings: any;
  modNewsUrl : any;
  quoteUrl: string;
  quoteParam: any;
 
  constructor(private _http: HttpClient,
    @Optional() @Inject('AppSettings') appSettings: any
    ) {
      this.modNewsUrl = appSettings.ibdConfigMap.modApiUrl;
    }

  navigateSymbol(symbol: any) {
    this.quoteUrl = "";
    this.quoteParam = {};
    this.getData(symbol, this.modNewsUrl).subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          let modSymbolResponse;
          let found = false;
          for (let k of data) {
            if (k.Symbol == symbol) {
              found = true;
              modSymbolResponse = k;
              break;
            }
          }

          if (this.symbolResponseAvailable(found, modSymbolResponse)) {
            this.updateQuoteVariables(symbol, modSymbolResponse);
          } else {
            this.quoteUrl = "/nxi/research/quotenews/overviewnews";
            this.quoteParam = { Symbol: symbol };
          }
          this.goto(this.quoteParam, this.quoteUrl);
        } else {
          this.goto(this.quoteParam, "/nxi/research/quotenews/overviewnews");
        }
      },
      (err) => {
        console.log(err);
        this.goto(this.quoteParam, "/nxi/research/quotenews/overviewnews");
      }
    );
  }

  private symbolResponseAvailable(found: boolean, modSymbolResponse: any) {
    return found && typeof modSymbolResponse !== "undefined";
  }

  private updateQuoteVariables(symbol: any, modSymbolResponse: any) {
    if (typeof modSymbolResponse["NormalIssueType"] !== "undefined") {
      if (modSymbolResponse["NormalIssueType"] == "S") {
        this.quoteUrl = "/nxi/research/quotenews/stocks/summary";
        this.quoteParam = { Symbol: symbol };
      } else if (modSymbolResponse["NormalIssueType"] == "ETF") {
        this.quoteUrl = "/nxi/research/quotenews/etf/etfsummary";
        this.quoteParam = { Symbol: symbol };
      } else if (modSymbolResponse["NormalIssueType"] == "MF") {
        this.quoteUrl = "/nxi/research/quotenews/mutualfunds/mfsummary";
        this.quoteParam = { Symbol: symbol };
      } else {
        this.quoteUrl = "/nxi/research/quotenews/overviewnews";
        this.quoteParam = { Symbol: symbol };
      }
    } else {
      this.quoteUrl = "/nxi/research/quotenews/overviewnews";
      this.quoteParam = { Symbol: symbol };
    }
  }

  private getData(symbol: any,modurl: any): any {
    let urlStart = modurl+'/public/lookup';
    let params = [];
    params.push("symbol=" + symbol + "&normalizeAssetType=true");
    let url = urlStart + "?" + params.join("&");
    return this._http.jsonp(url, "callback");
  }

 private goto(quoteParam: any, quoteUrl: string) {
    document.dispatchEvent(
      new CustomEvent("portal.gotoview", {
        detail: {
          gotoParams: quoteParam,
          gotoPage: quoteUrl,
        },
      })
    );
  }
}
